import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import type { PatchSubscriptionPaymentMethodBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

export function useUpdateSubscriptionPaymentMethod(patientId: string) {
  const api = useOsApi()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body: PatchSubscriptionPaymentMethodBody) => {
      const response = await api.patch('/patients/:patientId/subscription/payment-method', {
        params: { patientId },
        body,
      })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
    onSuccess: () => {
      toast.success('Subscription card updated')
      queryClient.invalidateQueries({ queryKey: ['patient', patientId, 'subscription'] })
    },
  })
}
